import React, { memo } from 'react'

import { Button } from '@surglogs-app/ui'

import { useAccountSettingsTranslation } from '../services'

interface SettingsUserEditPinModalFormSubmitButtonProps {
  disabled: boolean
}

export const SettingsUserEditPinModalFormSubmitButton = memo(
  ({ disabled }: SettingsUserEditPinModalFormSubmitButtonProps) => {
    const { t } = useAccountSettingsTranslation()
    return (
      <Button {...{ type: 'submit', disabled, variant: 'success' }}>
        {t('passwordConfirmationButton')}
      </Button>
    )
  },
)
